export default function moveToCellAbove(editor) {
  var tableId = editor.getCurrentTableId() || editor.value.document.getPreviousBlock(editor.value.startBlock.key).getIn(['data', 'tableId']);
  var cells = editor.getTableCells(tableId);
  var nextCell = editor.getCellAbove(editor.value.focusBlock);

  if (nextCell) {
    return editor.moveTo(nextCell.getFirstText().key);
  } else {
    var previousBlock = editor.value.document.getPreviousBlock(cells.first().key);

    if (previousBlock) {
      return editor.moveTo(previousBlock.getFirstText().key, editor.value.selection.end.offset);
    }

    return editor;
  }
}